import React from 'react';

/**
 * inlineBold.tsx — the whole "markdown" a tour card understands.
 *
 * Card bodies are authored in src/tours/*.md and the compiler
 * (scripts/build-tours.js) rejects every construct except `**bold**` and a
 * blank line between paragraphs. So the renderer can be this small — and it
 * has to be: react-markdown is ESM and breaks every jest suite that mounts
 * it, and a tour card is mounted in exactly the tests that guard it.
 */

/** Split a body on blank lines. Trims and drops empty paragraphs. */
export function splitParagraphs(body: string): string[] {
  return body
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter((p) => p.length > 0);
}

/**
 * `**word**` → <strong>. An unmatched `**` renders literally rather than
 * bolding the rest of the line (the compiler already refuses it; this is the
 * runtime's fail-safe for hand-edited data).
 */
export function renderInlineBold(text: string, keyPrefix: string = 'b'): React.ReactNode[] {
  const parts = text.split('**');
  if (parts.length % 2 === 0) return [text];
  const out: React.ReactNode[] = [];
  parts.forEach((part, i) => {
    if (part === '') return;
    if (i % 2 === 1) {
      out.push(
        <strong key={`${keyPrefix}-${i}`} style={{ color: '#f5f5f5', fontWeight: 600 }}>
          {part}
        </strong>,
      );
    } else {
      out.push(part);
    }
  });
  return out;
}
